import React from 'react';
import { connect } from 'react-redux';
import Stepper from '@/components/Stepper/Stepper';
import { getSafe } from '@/helpers/global';

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0
    }
  }

  render() {
    const { language, detailData, stepsData, data } = this.props;
    const { activeStep } = this.state;
    return (
      <React.Fragment>
        <div className='detail-container' style={{width:'100%'}}>
          <div className='title'>
            <span>{getSafe(() => language.common_apply)}</span> {getSafe(() => data.customSymbol)}
          </div>
          <Stepper steps={stepsData} activeStep={activeStep} mode={"time"} />
          <section className="table">
            <ul>
              {
                detailData && detailData.map((item, index) =>
                  <li key={index}>
                    <div className="left">{getSafe(() => language[item.label])}</div>
                    <div className="right">{item.value}</div>
                  </li>
                )
              }
            </ul>
            <div style={{padding:'10px 0 0 10px'}}>
              {getSafe(() => language.common_please_read)}<b onClick={()=>this.ref()} className='prospectus'>{getSafe(() => language.ipo_apply_prospectus)}</b>
            </div>
          </section>
        </div>
      </React.Fragment>
    )
  }

  ref(){
    const {applyDataResp, language} = this.props
    alert(getSafe(() => language.common_ipo_prospectus_alert))
    if(applyDataResp){
      if(language.title === 'zh_TW' || language.title === 'zh_CN'){
        if(applyDataResp.chineseProspectus){
          var tempWindow = window.open('_blank')
          tempWindow.location = "HTTP://" + applyDataResp.chineseProspectus;
        }else if(applyDataResp.prospectus){
          var tempWindow = window.open('_blank')
          tempWindow.location = "HTTP://" + applyDataResp.prospectus;
        }
      }else{
        if(applyDataResp.prospectus){
          var tempWindow = window.open('_blank')
          tempWindow.location = "HTTP://" + applyDataResp.prospectus;
        }
      }
    }
  }

}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(Details)
